import PageWrapper from '../components/UI/PageWrapper';
import ZendeskTicketService from '../components/Support/ZendeskTicketService';

const SupportPage = () => (
  <PageWrapper>
    <ZendeskTicketService />
  </PageWrapper>
);

export default SupportPage;